import { filter_properties } from "./filterProperties";
import { getThumbnail } from "./utils";
import type { ResultType } from "lib/types";
import { interpretAddress } from "lib/interpretAddress";

export const processResultForCard = (props, filters, portfolio, searchType, sizeMeasurementType) => {
  const { result } = props;

  // Skip the advert result types that may have been added for display
  if (result.docType === 'locations-advert' || result.docType === 'dx-advert') {
    return result;
  }

  const data: ResultType = {};

  Object.entries(result).forEach((k) => {
    const key = k[0];
    data[key] = result[key]?.hasOwnProperty("raw") ? result[key]?.raw : result[key]

    if (
      typeof data[key] === "object" &&
      !Array.isArray(data[key]) &&
      data[key] !== null &&
      Object.entries(data[key]).length === 0
    ) {
      data[key] = null;
    }
  });

  if (data.docType === 'scheme') {
    delete data.availability;
  }

  // Handle scheme properties.
  if (data.docType === "scheme" && data?.available_properties && data.available_properties?.length > 0) {
    filter_properties(filters, data);
  }

  if (data.docType === 'scheme') {
    let portfolioUrl = portfolio ? `/portfolio/${portfolio['uri']}` : '';
    data.resultHref = data.url
    if (data.uri) data.resultHref = `${portfolioUrl}/scheme/${data?.uri.toLocaleLowerCase()}-${data.id}`;
  } else {
    data.rent = data.rent_pa;
    data.resultHref = `/property/${data.url_fragment ? data.url_fragment : data.id}`;
  }

  data.full_name = data.name ? data.name : data.line1;
  data.size = data[sizeMeasurementType.key] ? data[sizeMeasurementType.key] : null;

  data.updated = [1, data.modified];

  data.address = interpretAddress(data);

  data.showExpandButton = data?.properties && data?.properties?.length > 1 ? true : false;

  data.thumbnail = getThumbnail(data, data.docType, data.category_code);

  if (data?.available_properties) {
    data.available_properties = data.available_properties.map((p) => {
      const thumbnail = p.images ? getThumbnail(p, data.docType, data.category_code) : null;
      return { ...p, images: thumbnail };
    })
  }
  data.showSponsorBadge = data.docType === 'scheme' || (data.docType !== 'property' && data.sponsored);

  if (data.docType === 'scheme' && data.sponsored !== true) {
    data.marketedBy = [];
  }

  data.owners = (data?.owners || []).filter(owner => owner.paying_client);
  return data;
}


export const cardMapCleanup = (r) => {
  const ok = { ...r };
  delete ok.updated;
  delete ok.search_rank;
  return ok;
}
